<template>
  <label>
    <input
      :type="inputType"
      :name="name"
      :value="valueAttr"
      class="peer absolute opacity-0 pointer-events-none"
      @blur="$emit('blur')"
      :checked="value"
      @change="handleChange"
      :required="required"
    />
    <span
      v-if="multiple"
      class="block
        relative
        w-4
        h-4
        transition-colors
        text-white
        bg-white
        rounded-[3px]
        border border-[#DEDEE4]
        mr-4
        peer-checked:bg-lime peer-checked:border-lime">
      <svg class="absolute -top-px -left-px w-4 h-4">
        <use xlink:href="#tick-16x16" />
      </svg>
    </span>
    <span class="font-[1rem] leading-none tracking-tight font-[500]" v-text="label"></span>
  </label>
</template>

<script>
export default {
  name: 'ChoiceOption',
  props: {
    name: String,
    multiple: Boolean,
    value: Boolean,
    valueAttr: [Number, String],
    label: String,
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputType() {
      return this.multiple ? 'checkbox' : 'radio'
    },
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e.target.checked)
    },
  },
}
</script>
